import { Controller } from "@hotwired/stimulus"

// Pendant que l'analyse IA tourne (asynchrone), interroge le statut et recharge
// la page dès qu'elle est prête (ou en erreur).
export default class extends Controller {
  static values = { url: String, status: String }

  connect() {
    if (this.statusValue === "pending") {
      this.tries = 0
      this.timer = setInterval(() => this.check(), 4000)
    }
  }

  check() {
    // Garde-fou : ~3 min max, pour ne pas tourner en boucle si le job meurt sans
    // écrire son statut d'erreur.
    if (++this.tries > 45) {
      clearInterval(this.timer)
      const el = this.element.querySelector(".bc-ia-pending")
      if (el) el.innerHTML = "L'analyse prend plus de temps que prévu. Rechargez la page dans un instant, ou relancez-la."
      return
    }
    fetch(this.urlValue, { headers: { Accept: "application/json" } })
      .then((r) => r.json())
      .then((j) => {
        if (j.status && j.status !== "pending") {
          clearInterval(this.timer)
          window.location.reload()
        }
      })
      .catch(() => {})
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }
}
